module.exports = __webpack_public_path__ + "static/11-bbe05f5721c0dbfd35239f35f8915491.png";